import React from "react";
import { FormattedMessage } from "./FormattedMessage";
import { SelectedToken } from "../store/SelectedTokensStore";

interface UserMessageProps {
  content: string;
  selectedTokens?: Map<string, SelectedToken>;
}

const UserMessage: React.FC<UserMessageProps> = ({
  content,
  selectedTokens = new Map(),
}) => {
  return (
    <div className="max-w-[400px] justify-center w-full flex-col items-end -pl-1 flex gap-3 relative">
      <div className="absolute left-0 right-0 shrink-0 bg-gradient-to-b from-synkColor/15 to-slate-600 h-[1px] flex w-full z-0"></div>
      <div className="flex flex-col justify-start max-w-[300px] w-full">
        {/* <div className="pt-0 pb-2 flex justify-end items-center w-full">
          <div className="flex flex-row justify-end items-center gap-1">
            <div className="max-w-5xl mx-auto text-center tracking-tight font-black bg-clip-text animated-heading text-transparent bg-gradient-to-br from-neutral-200 via-neutral-700 to-neutral-700 text-lg leading-none">
              YOU
            </div>
          </div>
        </div> */}
        <div className="relative border border-gray-800 overflow-hidden bg-white rounded-2xl z-40 w-full p-3 shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),_0px_1px_0px_0px_rgba(25,28,33,0.02),_0px_0px_0px_1px_rgba(25,28,33,0.08)]">
          <svg
            className="animate-spotlight pointer-events-none absolute opacity-100 -top-10 -left-20 rotate-6 z-[-1]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 3787 2842"
            fill="none"
          >
            <g filter="url(#filter)">
              <ellipse
                cx="1924.71"
                cy="273.501"
                rx="1924.71"
                ry="273.501"
                transform="matrix(-0.822377 -0.568943 -0.568943 0.822377 3631.88 2291.09)"
                fill="white"
                fillOpacity="0.21"
              ></ellipse>
            </g>
          </svg>
          <div className="text-base relative -tracking-tight gap-1 text-black">
            <FormattedMessage
              content={content}
              selectedTokens={selectedTokens}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserMessage;
